import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Dotcom2024Service } from '../../dotcom2024.service';

@Component({
  selector: 'app-peat',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './peat.component.html',
  styleUrl: './peat.component.css'
})
export class PeatComponent {

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Products/";

  constructor(public dotComService: Dotcom2024Service) { }

  ngOnInit(): void {
  }

}
